import React, { Component } from "react";
import { Button, Form, Buttton } from "antd";
import Profiledetail from "./Formdetail/ProfileDetail";
import Bankdetail from "./Formdetail/BankDetail";
// import Uploaddetail from "./Formdetail/UploadDetail";

class Kycform extends Component {
  // checkLoading() {
  //   if (
  //     (this.props.kycType === "Individual" &&
  //       this.props.activeStep === 4 &&
  //       this.props.currentStep === 1 &&
  //       Object.entries(this.props.files).length) ||
  //     (this.props.kycType === "Organisation" &&
  //       this.props.activeStep === 5 &&
  //       this.props.currentStep === 2 &&
  //       Object.entries(this.props.files).length)
  //   ) {
  //     if (
  //       this.props.files.hasOwnProperty("pan_card") &&
  //       !!this.props.files.pan_card.length &&
  //       !!this.props.files.pan_card[0]["response"] &&
  //       this.props.files.pan_card[0].response.success === 1
  //     ) {
  //       return false;
  //     } else {
  //       return true;
  //     }
  //   } else {
  //     return false;
  //   }
  // }

  disablebutton() {
    if (
      this.props.kycType === "Individual" &&
      this.props.activeStep === 4 &&
      this.props.currentStep === 1 &&
      Object.entries(this.props.files).length &&
      this.props.files.hasOwnProperty("pan_card") &&
      !!this.props.files.pan_card.length &&
      !!this.props.files.pan_card[0]["response"] &&
      this.props.files.hasOwnProperty("address_proof") &&
      !!this.props.files.address_proof.length &&
      !!this.props.files.address_proof[0]["response"]
    ) {
      return "ContinueEnable";
    } else if (
      this.props.kycType === "Individual" &&
      this.props.activeStep === 5 &&
      this.props.currentStep === 2 &&
      Object.entries(this.props.files).length &&
      this.props.files.hasOwnProperty("cancelled_cheque") &&
      !!this.props.files.cancelled_cheque.length &&
      !!this.props.files.cancelled_cheque[0]["response"]
    ) {
      return "ContinueEnable";
    } else if (
      this.props.kycType === "Organisation" &&
      this.props.activeStep === 4 &&
      this.props.currentStep === 1 &&
      Object.entries(this.props.files).length &&
      this.props.files.hasOwnProperty("gst_certificate") &&
      !!this.props.files.gst_certificate.length &&
      !!this.props.files.gst_certificate[0]["response"] &&
      this.props.files.hasOwnProperty("signatory_pan_card") &&
      !!this.props.files.signatory_pan_card.length &&
      !!this.props.files.signatory_pan_card[0]["response"]
    ) {
      return "ContinueEnable";
    } else if (
      this.props.kycType === "Organisation" &&
      this.props.activeStep === 5 &&
      this.props.currentStep === 2 &&
      Object.entries(this.props.files).length &&
      this.props.files.hasOwnProperty("cancelled_cheque") &&
      !!this.props.files.cancelled_cheque.length &&
      !!this.props.files.cancelled_cheque[0]["response"]
    ) {
      return "ContinueEnable";
    } else {
      return "ContinueDisable";
    }
  }

  render() {
    return (
      <>
        <Form>
          <Profiledetail
            currentStep={this.props.currentStep}
            form={this.props.form}
            questions={this.props.questions}
            step={this.props.step}
            totalSteps={this.props.totalSteps}
            kycType={this.props.kycType}
            files={this.props.files}
            kycData={this.props.kycData}
            phonecallChangeHandler={(val) =>
              this.props.phonecallChangeHandler(val)
            }
            toggleBackButton={() => this.props.toggleBackButton()}
            onFileUpload={(docType, files) =>
              this.props.onFileUpload(docType, files)
            }
            onremovepencard={(docType) => this.props.onremovepencard(docType)}
            onremoveAddressProof={(docType) =>
              this.props.onremoveAddressProof(docType)
            }
            onRemoveGstCertificate={(docType) =>
              this.props.onRemoveGstCertificate(docType)
            }
            onremovesignaturepencard={(docType) =>
              this.props.onremovesignaturepencard(docType)
            }
            visible={this.props.visible}
            toggleSupportModal={() => this.props.toggleSupportModal()}
            visible2={this.props.visible2}
            toggleSupportNumberModal={() =>
              this.props.toggleSupportNumberModal()
            }
            handleSupportPhoneChange={(field, value) =>
              this.props.handleSupportPhoneChange(field, value)
            }
            supportNumber2={this.props.supportNumber2}
            prefix_1={this.props.prefix_1}
            supportEmail2={this.props.supportEmail2}
            handleSupportEmailChange={(field, value) =>
              this.props.handleSupportEmailChange(field, value)
            }
            VerifyPhone={() => this.props.VerifyPhone()}
            VerifyEmail={() => this.props.VerifyEmail()}
            numberOtpLoading={this.props.numberOtpLoading}
            emailOtpLoading={this.props.emailOtpLoading}
            phoneverified={this.props.phoneverified}
            emailverified={this.props.emailverified}
            verifiedmsg={this.props.verifiedmsg}
            verifiedcontact={this.props.verifiedcontact}
            previousdatastoe={(key, value) =>
              this.props.previousdatastoe(key, value)
            }
            kycData1={this.props.kycData1}
          />
          <Bankdetail
            currentStep={this.props.currentStep}
            form={this.props.form}
            questions={this.props.questions}
            step={this.props.step}
            totalSteps={this.props.totalSteps}
            kycType={this.props.kycType}
            files={this.props.files}
            kycData={this.props.kycData}
            profileBakButton={() => this.props.profileBakButton()}
            onRemoveCancelCheque={(docType) =>
              this.props.onRemoveCancelCheque(docType)
            }
            onFileUpload={(docType, files) =>
              this.props.onFileUpload(docType, files)
            }
          />

          {/* <Uploaddetail
            step={this.props.step}
            totalSteps={this.props.totalSteps}
            kycType={this.props.kycType}
            files={this.props.files}
            kycData={this.props.kycData}
            onremovesignaturepencard={(docType) =>
              this.props.onremovesignaturepencard(docType)
            }
            onremovepencard={(docType) => this.props.onremovepencard(docType)}
            removeadharcard={(docType) => this.props.removeadharcard(docType)}
            removeAddresProof={(docType) =>
              this.props.removeAddresProof(docType)
            }
            onRemoveCancelCheque={(docType) =>
              this.props.onRemoveCancelCheque(docType)
            }
            onRemoveGstCertificate={(docType) =>
              this.props.onRemoveGstCertificate(docType)
            }
            onFileUpload={(docType, files) =>
              this.props.onFileUpload(docType, files)
            }
            questions={this.props.questions}
            currentStep={this.props.currentStep}
            goToNextStep={this.props.goToNextStep}
            form={this.props.form}
            uploadBcakButton={() => this.props.uploadBcakButton()}
          /> */}
        </Form>
        {/* ant-btn.btn-green.clickable-dropdown.ant-btn-disabled */}

        {this.props.currentStep === 3 ? null : (
          <>
            <Button
              className={`${this.disablebutton()}`}
              onClick={() => this.props.goToNextPart()}
              // loading={loading}
            >
              Continue
            </Button>
            <div className="skip-step">
              <a href="#!" onClick={() => this.props.goToNextStep(false)}>
                <Button className="skip-btn">Skip this step</Button>
              </a>
            </div>
          </>
        )}
      </>
    );
  }
}

export default Form.create()(Kycform);
